import { Button, Group, List, Loader, Paper, Stack, Text, Title } from '@mantine/core';
import { AdPlatform } from '@marketing-tool/shared';
import { useState } from 'react';

import { trpc } from '../../../lib/trpc';

export const CampaignIntegrityCheck = ({
    gameId,
    platform,
    campaignId,
}: {
    gameId: string;
    platform: AdPlatform;
    campaignId: string | number;
}) => {
    const [diagnostics, setDiagnostics] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);

    return (
        <Stack gap="md">
            <Group justify="space-between">
                <Title order={4}>Campaign Integrity Check</Title>
                <Button
                    variant="subtle"
                    leftSection={loading ? <Loader size={16} /> : undefined}
                    onClick={async () => {
                        setLoading(true);
                        try {
                            const query =
                                platform === AdPlatform.Line ? trpc.line.integrity.check : trpc.meta.integrity.check;
                            const result = await query.query({
                                gameId,
                                campaignId: campaignId.toString(),
                            });
                            setDiagnostics(result.problems.length === 0 ? ['All checks passed!'] : result.problems);
                        } catch (error) {
                            setDiagnostics([`Error: ${error instanceof Error ? error.message : 'Unknown error'}`]);
                        }
                        setLoading(false);
                    }}
                    disabled={loading}
                >
                    {loading ? 'Checking...' : 'Run Checks'}
                </Button>
            </Group>

            {diagnostics.length > 0 && (
                <Paper bg="light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))" radius="sm" p="md">
                    <List>
                        {diagnostics.map((diagnostic, index) => (
                            <List.Item key={index}>
                                <Text>{diagnostic}</Text>
                            </List.Item>
                        ))}
                    </List>
                </Paper>
            )}
        </Stack>
    );
};
